import * as React from "react";

function SvgLevelEasyActive(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 36 32" {...props}>
      <g
        stroke="#FFF"
        strokeWidth={2}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      >
        <path fill="#FFF" opacity={0.3} d="M26.5 7.5v17M18.5 15.5v9" />
        <path fill="#6CD0B7" d="M10.5 18.5v6" />
      </g>
    </svg>
  );
}

export default SvgLevelEasyActive;
